import * as React from 'react';
import { SVGProps } from 'react';

const SvgCloseGray = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M8.92 8 16 15.08l-.92.92L8 8.92.92 16 0 15.08 7.08 8 0 .92.92 0 8 7.08 15.08 0l.92.92L8.92 8Z"
            fill="#f5f5f5"
        />
    </svg>
);

export default SvgCloseGray;
